import Box from "@mui/material/Box";
import ZoomBox from "./ZoomBox";
import ZoomButton from "./ZoomButton";

const root_ = (theme) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: "4px",
  "& .MuiButton-root": {
    color: "black",
  },
});

export default function Zoom() {
  return (
    <>
      <Box sx={root_}>
        <ZoomBox />
        <ZoomButton factor={0.5} />
      </Box>
    </>
  );
}
